import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { Tooltip } from '@mui/material';

interface HelpTipProps {
  title: string;
}

const HelpTip = ({ title }: HelpTipProps) => (
  <Tooltip title={title} placement="top">
    <HelpOutlineIcon sx={{ fontSize: 14, color: 'text.secondary', verticalAlign: 'middle', cursor: 'help' }} />
  </Tooltip>
);

export default HelpTip;
